import { render } from "./TermsView.vue?vue&type=template&id=7bdd39b9&scoped=true"
const script = {}

import "./TermsView.vue?vue&type=style&index=0&id=7bdd39b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdd39b9"]])

export default __exports__